import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCroissant } from '@fortawesome/pro-solid-svg-icons'

interface BreadGptMarkProps {
  /** Square size in px. */
  size?: number
  className?: string
}

/** The BreadGPT brand mark: a white croissant on the brand-red rounded square.
 *  Same croissant as the loading spinner, for a coherent identity. */
const BreadGptMark: React.FC<BreadGptMarkProps> = ({ size = 40, className = '' }) => (
  <span
    className={`breadgpt-mark ${className}`}
    style={{ width: size, height: size, fontSize: size * 0.56 }}
    role="img"
    aria-label="BreadGPT"
  >
    <FontAwesomeIcon icon={faCroissant} />
  </span>
)

export default BreadGptMark
